import { render, staticRenderFns } from "./BaseDropZone.vue?vue&type=template&id=3e7ad90c&scoped=true&"
import script from "./BaseDropZone.vue?vue&type=script&lang=ts&"
export * from "./BaseDropZone.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDropZone.vue?vue&type=style&index=0&id=3e7ad90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7ad90c",
  null
  
)

export default component.exports